import React from 'react';

var LoadingItems = function LoadingItems() {
  return React.createElement("div", {
    className: 'str-chat__loading-channels-item'
  }, React.createElement("div", {
    className: 'str-chat__loading-channels-avatar'
  }), React.createElement("div", {
    className: 'str-chat__loading-channels-meta'
  }, React.createElement("div", {
    className: 'str-chat__loading-channels-username'
  }), React.createElement("div", {
    className: 'str-chat__loading-channels-status'
  })));
};

var UnMemoizedLoadingChannels = function UnMemoizedLoadingChannels() {
  return React.createElement("div", {
    className: 'str-chat__loading-channels'
  }, React.createElement(LoadingItems, null), React.createElement(LoadingItems, null), React.createElement(LoadingItems, null));
};
/**
 * Loading indicator for the ChannelList
 */


export var LoadingChannels = React.memo(UnMemoizedLoadingChannels);